import Header from '../../Containers/Header/Header';
import Cover from "../../Containers/Cover/Cover";
import Footer from '../../Containers/Footer/Footer';
import {Fragment} from 'react';

const Home = ({URLS}) => {
	return (
		<Fragment>
			<Header URLS={URLS}/>
			<Cover/>
			<Footer URLS={URLS}/>
		</Fragment>
	)
};

export default Home;